import ServiceAcceptance from '@/views/ServiceAcceptance/index.vue'

const ServiceAcceptanceRouter = {
  path: '/service-acceptance',
  name: 'ServiceAcceptance',
  component: ServiceAcceptance,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default ServiceAcceptanceRouter
